module.exports = __webpack_public_path__ + "img/IISc_logo.9028a86b.png";